import { OktaAuth } from "@okta/okta-auth-js";
import { KeysEnum } from "./localStorage/types";

const BASENAME = process.env.OKTA_REDIRECT_BASE_URI;
const ISSUER = process.env.OKTA_ISSUER;
const CLIENT_ID = process.env.OKTA_CLIENT_ID;

if (!ISSUER) {
  throw new Error("OKTA_ISSUER is not set");
}
if (!CLIENT_ID) {
  throw new Error("OKTA_CLIENT_ID is not set");
}
if (!BASENAME) {
  throw new Error("OKTA_REDIRECT_BASE_URI is not set");
}

// IL2 prod is reachable via two hostnames (il2.gov.teamworksapp.com and
// teamworksgov.com). Keep the configured base path but use the origin the SPA
// was actually loaded from, so the PKCE/state transaction stored on the
// starting origin is found when Okta redirects back.
const { pathname } = new URL(BASENAME, window.location.origin);
const redirectBasePath = pathname.endsWith("/") ? pathname : `${pathname}/`;
const REDIRECT_URI = `${window.location.origin}${redirectBasePath}login/callback`;

export const oktaAuth = new OktaAuth({
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: ["openid", "profile", "email"],
  pkce: true,
  tokenManager: {
    // Namespace token storage so other SPAs on this origin (e.g. TW Auth at
    // /tw-auth) can't overwrite Axle's tokens in the okta-auth-js default
    // bucket. This MUST live on tokenManager: TokenManager's DEFAULT_OPTIONS
    // hardcode storageKey to "okta-token-storage" and always pass it through,
    // overriding any storageManager.token.storageKey (okta-auth-js 7.x).
    storageKey: KeysEnum.OKTA_TOKEN_STORAGE,
    storage: "localStorage",
    expireEarlySeconds: 60,
    autoRenew: true,
    secure: true,
  },
});
